import { getByShortcut } from '@/infra/items/ItemRepository';
import Archive from '@/domain/archives/index';

interface Props {
  type: 'launch' | 'archive';
  shortcutId: number;
}
export async function itemsGetByShortcuts(props: Props): Promise<ResolvedData> {
  try {
    const res = await getByShortcut(props);
    const items = res.items.map((item) => new Archive(item));
    return {
      ...res,
      items,
    };
  } catch (error: any) {
    if (error.message === 'ServerError') {
      throw error;
    }
    throw error;
  }
}

export default itemsGetByShortcuts;

export type ResolvedData = {
  items: Archive[];
  lastId?: string;
  scrollId?: string;
  totalCount?: number;
  eventIds?: number[];
  nextPage?: boolean;
};
